import React, { useRef } from 'react'
import { Img, SearchAssets } from 'components';
import { Wrapper, ImageWrapper } from './styles'
import { useAssets, useMyContext } from 'hooks';

const SearchHeader = ({ period, initialApplication }) => {
  const searchStringRef = useRef();
  const { history, theme } = useMyContext();
  const { addAsset, removeAllAssets } = useAssets();
  const { innerWidth } = window;

  const imageClick = () => {
    removeAllAssets();
    history.push('/');
  }

  return (
    <Wrapper>
      <ImageWrapper>
        <Img onClick={imageClick} src={theme.logo.img} />
      </ImageWrapper>
      <SearchAssets period={period} addAsset={addAsset} initialApplication={initialApplication} searchStringRef={searchStringRef} style={innerWidth > 920 ? {marginLeft: "40px"} : {}}/>
    </Wrapper>
  );
}

export default SearchHeader;
